import React from 'react';
import PropTypes from 'prop-types';

import Badge from '../../components/badge';
import Tooltip from '../../components/tooltip';

import './ClassificationBadge.scss';

var ClassificationBadge = function ClassificationBadge(_ref) {
    var tooltip = _ref.tooltip,
        tooltipPosition = _ref.tooltipPosition,
        value = _ref.value;

    var badge = React.createElement(
        Badge,
        { className: 'classification-badge', type: 'warning' },
        value
    );

    return tooltip ? React.createElement(
        Tooltip,
        { position: tooltipPosition, text: tooltip },
        badge
    ) : badge;
};

ClassificationBadge.propTypes = {
    tooltip: PropTypes.string,
    tooltipPosition: PropTypes.string,
    value: PropTypes.string.isRequired
};

export default ClassificationBadge;